export default __webpack_public_path__ + "static/media/text.03d4c58a.svg";